import { TeamLegalCasesGetters } from './partials/legal_cases'
import { TeamMemberGetters } from './partials/members'
import { TeamPartyGetters } from './partials/parties'
import { TeamRecordGetters } from './partials/records'
import { TeamRoleGetters } from './partials/roles'

export const TeamGetters = {
  teams: state => state.teams,
  ...TeamLegalCasesGetters,
  ...TeamMemberGetters,
  ...TeamPartyGetters,
  ...TeamRecordGetters,
  ...TeamRoleGetters,
}
